import createApiClient from "./api";

const client = createApiClient();

export const api = {
  addDemography: ({ orgId,cohortId, payload }) =>
    client
      .post(`/admin/org/${orgId}/cohorts/${cohortId}/demographics`, payload)
      .then(({ data }) => data),

  
  getDemography: () =>
    client
      .get(`/admin/demographics`)
      .then(({ data }) => data),

  getPayGrades: (orgId) =>
    client
      .get(`/admin/org/${orgId}/pay-grades`)
      .then(({ data }) => data),

  getCountries: () =>
    client
      .get(`/countries`)
      .then(({ data }) => data),

  getGender: (orgId) =>
    client
      .get(`/admin/org/${orgId}/gender`)
      .then(({ data }) => data),

  getDivisions: ({ orgId }) =>
    client
      .get(`/admin/org/${orgId}/divisions`)
      .then(({ data }) => data),
};
